import * as THREE from 'three'
import Experience from '../Experience'
import GSAP from 'gsap'

export default class Dxm {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    this.time = experience.time
    this.debug = experience.debug

    if (this.debug.active) {
    }
    //main link model
    this.resource = this.resources.items.dxm

    //Methods
    this.setMaterial()
    this.setModel()
    this.eventMesh()
  }
  setMaterial() {
    //logo material
    this.logoMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff,
    })
    //tablet material
    this.tabletTexture = this.resources.items.home
    this.tabletTexture.encoding = THREE.sRGBEncoding
    this.tabletTexture.flipY = false
    this.tabletMaterial = new THREE.MeshBasicMaterial({
      map: this.tabletTexture,
    })
    //stand material
    this.standTexture = this.resources.items.stand
    this.standTexture.flipY = false
    this.standTexture.encoding = THREE.sRGBEncoding
    this.standMaterial = new THREE.MeshBasicMaterial({
      map: this.standTexture,
    })

    /**
     * VIDEO
     */
    //Porsche
    this.videoPorsche = {}
    this.videoPorsche.element = document.querySelector('.porsche')
    this.videoPorscheTexture = new THREE.VideoTexture(this.videoPorsche.element)
    this.videoPorscheTexture.flipY = false
    this.videoPorscheTexture.encoding = THREE.sRGBEncoding

    this.videoPorscheMaterial = new THREE.MeshBasicMaterial({
      map: this.videoPorscheTexture,
    })
    // // //Turtle
    this.videoTurtle = {}
    this.videoTurtle.element = document.querySelector('.turtle')

    this.videoTurtleTexture = new THREE.VideoTexture(this.videoTurtle.element)
    this.videoTurtleTexture.flipY = false
    this.videoTurtleTexture.encoding = THREE.sRGBEncoding

    this.videoTurtleMaterial = new THREE.MeshBasicMaterial({
      map: this.videoTurtleTexture,
    })
    // //Nike
    this.videoNike = {}
    this.videoNike.element = document.querySelector('.nike')

    this.videoNikeTexture = new THREE.VideoTexture(this.videoNike.element)
    this.videoNikeTexture.flipY = false
    this.videoNikeTexture.encoding = THREE.sRGBEncoding

    this.videoNikeMaterial = new THREE.MeshBasicMaterial({
      map: this.videoNikeTexture,
    })

    //screen material 1
    this.screenTexture1 = this.resources.items.car
    this.screenTexture1.flipY = false
    this.screenTexture1.encoding = THREE.sRGBEncoding

    this.screenMaterial1 = new THREE.MeshBasicMaterial({
      map: this.screenTexture1,
    })

    //screen material 2
    this.screenTexture2 = this.resources.items.turtle
    this.screenTexture2.flipY = false
    this.screenTexture2.encoding = THREE.sRGBEncoding
    this.screenMaterial2 = new THREE.MeshBasicMaterial({
      map: this.screenTexture2,
    })
    //screen material 3
    this.screenTexture3 = this.resources.items.shoe
    this.screenTexture3.flipY = false
    this.screenTexture3.encoding = THREE.sRGBEncoding

    this.screenMaterial3 = new THREE.MeshBasicMaterial({
      map: this.screenTexture3,
      // map: this.videoNikeTexture,
    })
  }

  setModel() {
    //model
    this.model = this.resource.scene

    //model children
    this.logo = this.model.children.find(child => child.name === 'logo')
    this.screen1 = this.model.children.find(child => child.name === 'screen1')
    this.screen2 = this.model.children.find(child => child.name === 'screen2')
    this.screen3 = this.model.children.find(child => child.name === 'screen3')
    this.tablet = this.model.children.find(child => child.name === 'tablet')
    this.stand = this.model.children.find(child => child.name === 'stand')

    this.screen1.material = this.screenMaterial1
    this.screen2.material = this.screenMaterial2
    this.screen3.material = this.screenMaterial3
    this.logo.material = this.logoMaterial
    this.tablet.material = this.tabletMaterial
    this.stand.material = this.standMaterial

    //add model to scene
    this.scene.add(this.model)
  }
  eventMesh() {
    const button = document.querySelector('.decouvrir')
    button.addEventListener('click', () => {
      setTimeout(() => {
        this.screen1.material = this.videoPorscheMaterial
        this.screen2.material = this.videoTurtleMaterial
        // this.screen3.material = this.videoNikeMaterial
      }, 500)
    })
  }

  update() {}
}
